import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer>
            <div className="footer-container py-4 text-white text-center ">
                <small>Copyright © 2021 <span className="name">Antor</span> All Rights Reserved.</small>
            </div>
        </footer>
    );
};

export default Footer;